//External
import React,{ useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//Internal
import { showSuccessPopup } from "../../store/actions";

/*******************
@Purpose : Used for success pop up
@Parameter : { addOnClass, message, error = false }
@Author : INIC
******************/
function SuccessPopup({ addOnClass, message, error = false }) {
  const dispatch = useDispatch()
  const alert = useSelector((state) => state?.ui?.showSuccessAlert);

  /*******************
@Purpose : React Hooks Used for dispatch success pop up
@Parameter : { }
@Author : INIC
******************/
  useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        dispatch(showSuccessPopup('', false, false))
      }, 3000);
    }
  }, [alert])

 /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <div className={`success-popup ${error ? 'error' : ''} ${addOnClass}`}>
      <div className="success-popup-backdrop"></div>
      <div className="success-popup-inner">
        <div className="success-popup-body">
          <div className="icon-box">
            <span className="icon icon-check success-icon mr-0"></span>
            <span className="icon icon-close-2 error-icon mr-0"></span>
          </div>
          <span className="success-text">
            {message}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SuccessPopup;
